<template>
    <div>
        <board-detail-link :detailLayout="detailLayout" :boardData="boardData" :setData="setData"></board-detail-link>
    </div>
</template>

<script>
    import BoardValidator from "@/mixins/validators/BoardValidator"
    import boardTemplateUtil from "@/components/board/boardTemplateUtil"
    import boardFilterUtil from "@/components/board/boardFilterUtil"
    import BoardDetailLink from "@/components/board/BoardDetailLink";
    import VuxAlert from '@/mixins/vux-alert';
    import EventBus from "@/utils/event-bus";
    export default {
        name: "BoardDetailComponent",
        mixins: [boardTemplateUtil, boardFilterUtil, VuxAlert, BoardValidator ],
        components: {
            BoardDetailLink
        },
        props: {
            boardType: {
                type: String,
                default: '',
            },
            boardKey: {
                default: null,
            },
            cafeKey: {
                type : Number,
                default: ()=>{ return 0},
            }
        },
        data() {
            return{
                detailLayout: '',
                getCategoryFunc: null,
                subFunc: '',
                getFunc: '',
                parsingData: {},
                categorys: {
                    list: [],
                    parsing: {},
                },
                sendFileType: '',
                createApiParamSet: {},
                detailApiParamSet: {},
                directUrl: '',
                resultAlertTxt: '',
                boardData: {},
                detailSuccessType:''
            }
        },
        beforeRouterEnter() {},
        created() {
            this.initConfig();
        },
        mounted() {
            EventBus.$on('writeBoard', this.writeBoard);
        },
        beforeDestroy() {
            EventBus.$off('writeBoard');
        },
        destroyed() {},
        computed: {
        },
        methods:{
            initConfig() {
                let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
                this.getCategoryFunc = boardFilterConfig.getCategoryFunc ? boardFilterConfig.getCategoryFunc : null;
                this.getFunc = boardFilterConfig.getFunc;
                this.detailApiParamSet = boardFilterConfig.detailApiParamSet;
                if(this.boardKey != null) {
                    this.id = this.boardKey;
                    this.getInfo();
                }else{
                    this.initTemplateConfig();
                }
                this.subFunc = boardFilterConfig.subFunc;
                this.parsingData = boardFilterConfig.parsingData;
                this.sendFileType = boardFilterConfig.sendFileType;
                this.directUrl = boardFilterConfig.directUrl;
                this.createApiParamSet = boardFilterConfig.createApiParamSet;
                this.resultAlertTxt = boardFilterConfig.resultAlertTxt;
                this.detailSuccessType = boardFilterConfig.detailSuccessType
            },
            initTemplateConfig() {
                let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
                this.detailLayout = boardTemplateConfig.detailLayout;
            },
            setData(key, value) {
                this[key] = value;
            },
            getInfo() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = Number(this.id);
                if(this.cafeKey !== 0){
                    params.bcid = this.cafeKey
                }
                 try {
                      this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type !== this.detailSuccessType) {
                            this.createAlert({
                                title: '',
                                content: '데이터가 없습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                            return false;
                        }
                        this.boardData = res.List[0];
                    })
                }catch (e) {
                    console.log(e);
                }
                        this.initTemplateConfig();
            },
            writeBoard() {
                let dataKeys = Object.keys(this.parsingData);
                this.$validate(dataKeys).then((success) => {
                    if(!success) {
                        this.errorAlert('모두 입력해주세요.');
                        return false;
                    }
                    let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                    dataKeys.forEach(dataKey => {
                        params[this.parsingData[dataKey]] = this[dataKey];
                    });
                    try {
                        this.$api.$board[this.subFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type != 1) {
                                this.errorAlert(res.Info.reason);
                                return false;
                            }

                            this.createAlert({
                                title: '확인',
                                content: this.resultAlertTxt,
                                btnText: '확인',
                                hide: () => {
                                    if(this.directUrl === '') {
                                        return false;
                                    }
                                    if(this.directUrl === 'back') {
                                        this.$router.back();
                                        return false;
                                    }
                                    let url = this.directUrl;
                                    if(this.directType === 'detail') {
                                        url = url+res.List;
                                    }
                                    this.$router.push(url);
                                }
                            })
                        })
                    }catch (e) {
                        console.log(e);
                    }
                })
            },
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>